import React, { Component } from 'react';
import {Bar, Line} from 'react-chartjs-2';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';





class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
      navigate: false,
      path:""
    };
  }


  componentWillMount() {

     if(!this.props.user.isLoggedIn) {
          this.setState({
            path:"login",
            navigate:true

          })
        }

  }


  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }


  render() {

    const { navigate, path } = this.state

    // here is the important part
    if (navigate) {
      console.log(path);
      return <Redirect to={ "/" + path } push={true} />
    }


    return (
      <div className="animated fadeIn welcome-body-wrapper">
          <div className="welcome-content">
            <div className="welcome-inner">
              <h1>Welcome to Cinefly</h1>
                <p>
                  This site is your Cinefly Storyteller Portal.  Here you’ll be able to view and request Storyboards.  You can also view and download user generated shots and movies.
                </p>
                <p>
                Just remember to download the assets you need before suspending a Storyboard or moving a Storyboard between Dev and Live as these actions archive the assets.
                </p>
                <p>
                  If you have any questions or need help please contact us on: <a href="hello@cinefly.io">hello@cinefly.io</a> 
                </p>
              <strong>Cinefly Team</strong>
            </div>
          </div>
      </div>
    )
  }
}


function mapStateToProps(state) {
    return {
        user: state.activeUser
    };
}


export default connect(mapStateToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js